import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CategoryDashboard.css';


const CategoryDashboard = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({ name: '', description: '', image: null });
  const [editCategory, setEditCategory] = useState(null);
  const API_URL = 'https://admin.rosenwell.com/categories';

  // Fetch categories
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(API_URL);
      setCategories(response.data);
      console.log(response.data)
    } catch (error) {
      toast.error('Failed to fetch categories');
    }
  };

  // Handle image selection for new category
  const handleNewImageChange = (e) => {
    setNewCategory({ ...newCategory, image: e.target.files[0] });
  };

  // Handle image selection for edit category
  const handleEditImageChange = (e) => {
    setEditCategory({ ...editCategory, image: e.target.files[0] });
  };

  // Add a new category
  const handleAddCategory = async () => {
    const formData = new FormData();
    formData.append('name', newCategory.name);
    formData.append('description', newCategory.description);
    if (newCategory.image) {
      formData.append('image', newCategory.image);
    }

    try {
      await axios.post(`${API_URL}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Category added successfully');
      setNewCategory({ name: '', description: '', image: null });
      fetchCategories();
    } catch (error) {
      toast.error('Failed to add category');
    }
  };

  // Update a category
  const handleUpdateCategory = async () => {
    const formData = new FormData();
    formData.append('name', editCategory.name);
    formData.append('description', editCategory.description);
    if (editCategory.image) {
      formData.append('image', editCategory.image);
    }

    try {
      await axios.put(`${API_URL}/${editCategory._id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Category updated successfully');
      setEditCategory(null);
      fetchCategories();
    } catch (error) {
      toast.error('Failed to update category');
    }
  };

  // Delete a category
  const handleDeleteCategory = async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      toast.success('Category deleted successfully');
      fetchCategories();
    } catch (error) {
      toast.error('Failed to delete category');
    }
  };

  return (
    <div className="container">

      <h1>Admin Panel</h1>
      <hr />
      <ToastContainer />
      <h2>Category Dashboard</h2>

      {/* Add Category Form */}
      <div style={{ maxWidth: "400px", margin: "20px auto", padding: "20px", border: "1px solid #ccc", borderRadius: "8px", boxShadow: "2px 2px 10px rgba(0,0,0,0.1)", backgroundColor: "#f9f9f9" }}>
  <h3 style={{ textAlign: "center", color: "#333", marginBottom: "15px" }}>Add New Category</h3>

  <input
    type="text"
    placeholder="Name"
    value={newCategory.name}
    onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
    style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", marginBottom: "10px" }}
  />

  <textarea
    placeholder="Description"
    value={newCategory.description}
    onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
    style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", marginBottom: "10px", minHeight: "80px" }}
  />

  <input
    type="file"
    accept="image/*"
    onChange={handleNewImageChange}
    style={{ width: "100%", marginBottom: "15px" }}
  />

  <button
    onClick={handleAddCategory}
    style={{
      width: "100%",
      padding: "10px",
      backgroundColor: "#28a745",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background 0.3s",
    }}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
  >
    Add Category
  </button>
</div>

      {/* Edit Category */}
      {editCategory && (
        <div>
          <h3>Edit Category</h3>
          <input
            type="text"
            value={editCategory.name}
            onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })}
          />
          <textarea
            value={editCategory.description}
            onChange={(e) =>
              setEditCategory({ ...editCategory, description: e.target.value })
            }
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleEditImageChange}
          />
          <button onClick={handleUpdateCategory}>Update Category</button>
          <button onClick={() => setEditCategory(null)}>Cancel</button>
        </div>
      )}

      {/* Category List */}
      <h3>Category List</h3>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category._id}>
              <td>{category.name}</td>
              <td>{category.description}</td>
              <td>
                {category.image && (
                  <img
                    src={`https://admin.rosenwell.com${category.image}`}
                    alt={category.name}
                    style={{ width: '50px', height: '50px', margin: '5px' }}
                  />
                )}
              </td>
              <td>
                <button onClick={() => setEditCategory(category)}>Edit</button>
                <button onClick={() => handleDeleteCategory(category._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    
    </div>
  );
};

export default CategoryDashboard;
